import type { ReactNode } from 'react';
import { X } from 'lucide-react';

import { cn } from '../../lib/cn';
import styles from './Chip.module.css';

export type ChipTone = 'neutral' | 'primary' | 'danger';

export type ChipProps = {
  readonly children: ReactNode;
  readonly tone?: ChipTone;
  readonly removable?: boolean;
  readonly onRemove?: () => void;
  readonly onClick?: () => void;
  readonly color?: string;
  readonly title?: string;
};

/** Метки и приоритеты (docs/06 §4). */
export function Chip({ children, tone = 'neutral', removable = false, onRemove, onClick, color, title }: ChipProps) {
  return (
    <span className={cn(styles['chip'], styles[tone])} title={title}>
      {color ? <span aria-hidden className={styles['dot']} style={{ background: color }} /> : null}
      {onClick ? (
        <button type="button" className={styles['labelButton']} onClick={onClick}>
          {children}
        </button>
      ) : (
        <span className={styles['label']}>{children}</span>
      )}
      {removable ? (
        <button type="button" aria-label="Убрать метку" className={styles['remove']} onClick={onRemove}>
          <X aria-hidden size={12} />
        </button>
      ) : null}
    </span>
  );
}
